import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem, SortEvent } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Viewdata, GlobalMessage, Versions } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { LoginpagemessagesService } from './loginpagemessages.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { LoginpagemessagesmodalComponent } from '../../directives/loginpagemessagesmodal/loginpagemessagesmodal.component';
@Component({
  selector: 'app-loginpagemessages',
  templateUrl: './loginpagemessages.component.html',
  styleUrls: ['./loginpagemessages.component.css']
})
export class LoginpagemessagesComponent {
  showcount: number = 0;
  hidecount: number = 0;
  working: boolean = true;
  ref: DynamicDialogRef | undefined;
  selectedProduct = false;
  commonScrollHeight = '';
  numberofrowsingrid: number = 10;
  totalRecords: number = 0;
  isActivefilter = false
  options = [];
  paginatorArray = []
  buttonOption = [];
  tab = 1;
  items: MenuItem[] | undefined;
  selectedItem: MenuItem | null = null;
  tableData: any[] = [];
  excel_paragraph = '';
  templatedownloadtext = '';
  exceldownloadModal = false;
  searchText: string;
  helplist: any;
  listarray: Array<Versions> = [];
  sortOrder = 1;
  sortProperty: string = 'id';
  versionRequest: Versions = new Versions();
  versionUpdatereq: Versions = new Versions();
  versions: any;
  versionssarray: Array<Versions>;
  versiontype: any;
  versionarray: Array<Versions> = [];
  dataview: Viewdata = new Viewdata();
  buttunText = "Add New"
  isButtonraised: boolean = true;
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 20, 50, 100];
  tablecount: number = 0;
  numberofrowsintable: number = 10;
  visible: boolean = false;
  position = 'top';
  cols = [];
  _selectedColumns = [];
  message: GlobalMessage = new GlobalMessage()

  constructor(
    private LoginpagemessagesService: LoginpagemessagesService,
    public router: Router,
    //private dashbordservice: DashboardService,
    public dialogService: DialogService,
    private spinner: NgxSpinnerService,
    public helpservice: PagehelpmodalService,
    private utilityservice: Utilityservice) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text
  }
  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.gettabledata();
  }

  onMenuItemClick(event: any): void {
    this.selectedItem = event.item;
    if (this.selectedItem.command) {
      this.selectedItem.command();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    console.log(this.commonScrollHeight);
  }


  gettabledata() {
    this.LoginpagemessagesService.gettabledata().subscribe((data) => {
      this.helplist = data;
      this.listarray = this.helplist;
      this.options = this.LoginpagemessagesService.getOptionDropdown(data.length);
      this.paginatorArray = this.options.map(e => e.value)
      this.listarray.map(e => {
        e['isSelect'] = false
      })
      this.totalRecords = this.listarray.length;
      this.tablecount = this.helplist.count;
    });
    this.LoginpagemessagesService.gettabledata().subscribe((data: any) => {
      this.helplist = data;
    });
  }

  handlePageChange(event: any) {
    this.numberofrowsintable = event.rows
  }

  filedata: any = []
  setEvent(event) { this.filedata = event }
  handleDialogClose() { this.filedata = []; }


  show(title, data) {
    let details = {};
    this.spinner.show();
    this.LoginpagemessagesService.getview(data.rid).subscribe((res: any) => {
      this.spinner.hide();
      if (res.length === 0) {
        const timestamp = new Date().toLocaleString(); // example timestamp
        Swal.fire({
          title: 'Data Not Found',
          text: `This event occurred at: ${timestamp}`,
          icon: 'error'
        })
      } else {
        details = res;
        this.ref = this.dialogService.open(LoginpagemessagesmodalComponent, {
          header: title,
          width: '90vw',
          height: '90%',
          data: { title: title, datas: details },
          contentStyle: { overflow: 'hidden' },
          maximizable: true,
        });
        this.ref.onClose.subscribe(() => {
          this.gettabledata();
        });
      }
    }, error => {
      this.spinner.hide();
      const timestamp = new Date().toLocaleString(); // example timestamp
      Swal.fire({
        title: error.error.error,
        text: `This event occurred at: ${timestamp}`,
        icon: 'error'
      })

    });
  }


  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      // Handling null values
      if (value1 == null && value2 != null) return -1;
      if (value1 != null && value2 == null) return 1;
      if (value1 == null && value2 == null) return 0;

      // Check if the field is createdon for date comparison
      if (event.field === 'fromdate' || event.field === 'todate') {
        // Parse the date strings to Date objects
        const date1 = new Date(value1);
        const date2 = new Date(value2);
        return date1.getTime() - date2.getTime(); // Sort by timestamp
      }

      // Handle string comparisons
      if (typeof value1 === 'string' && typeof value2 === 'string') {
        return value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
      }

      // Fallback to default number comparison for other types
      return (value1 < value2 ? -1 : (value1 > value2 ? 1 : 0));
    });

    return event.order === -1 ? event.data.reverse() : event.data; // Reverse if descending
  }
  searchTerm: string = '';
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }
}
